import { useState, useEffect } from 'react';
import { IS_LIST_VIEW_KEY } from '../constants';
import { sendChangeViewAnalyticsEvent } from '../helpers/analitycs';

export const useViewMode = () => {
  const [isListView, setIsListView] = useState(false);

  const handleViewMode = () => {
    setIsListView((prev) => {
      const newValue = !prev;
      window.localStorage.setItem(IS_LIST_VIEW_KEY, JSON.stringify(newValue));
      sendChangeViewAnalyticsEvent(newValue);
      return newValue;
    });
  };

  useEffect(() => {
    const isListView = JSON.parse(
      window.localStorage.getItem(IS_LIST_VIEW_KEY) || 'false',
    );
    setIsListView(isListView);
  }, []);

  return { isListView, handleViewMode };
};
